<!-- eslint-disable -->
<template lang="pug">
		.settings(v-if='settings')
				template
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_viewTypeLeft') }}:
								| {{ $i18n.t('couples.couples_view_' + settings.leftColumn) }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_viewTypeRight') }}:
								| {{ $i18n.t('couples.couples_view_' + settings.rightColumn) }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfPairs') }}:
								| {{ settings.amountOfPairs }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
								| {{ settings.numOfExamples }}
						br
				br
				slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            }
        }
    }
</script>
